import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Productie/RuteModels.cs ----------

export type ProductionRouteStatus = 'Draft' | 'PendingApproval' | 'Activa' | 'Arhivata' | 'Respinsa'
export type ProductionOperationType =
  | 'AlimentareFolie' | 'Incalzire' | 'Formare' | 'Racire' | 'TaiereStantare' | 'Stivuire' | 'ControlVizual' | 'Ambalare' | 'Paletizare' | 'Altele'

export interface RouteListItem {
  id: string; number: string; productArticleId: string; productArticleCode: string; productArticleDescription: string
  status: ProductionRouteStatus; operationCount: number
}

export interface RouteOperationEquipment { equipmentId: string; equipmentCode: string; equipmentName: string }

export interface RouteOperation {
  id: string; sequenceOrder: number; type: ProductionOperationType; name: string
  setupTimeMinutes: number | null; cycleTimeSecondsPerUnit: number | null; expectedYieldPercent: number | null
  requiresQualityCheckpoint: boolean; allowsOverlapWithNext: boolean
  wipArticleId: string | null; wipArticleCode: string | null; wipArticleDescription: string | null
  compatibleEquipment: RouteOperationEquipment[]
}

export interface RouteDetail {
  id: string; number: string; productArticleId: string; productArticleCode: string; productArticleDescription: string
  status: ProductionRouteStatus; notes: string | null; operations: RouteOperation[]
}

export interface SaveRouteOperationPayload {
  sequenceOrder: number; type: ProductionOperationType; name: string
  setupTimeMinutes: number | null; cycleTimeSecondsPerUnit: number | null; expectedYieldPercent: number | null
  requiresQualityCheckpoint: boolean; allowsOverlapWithNext: boolean; wipArticleId: string | null; compatibleEquipmentIds: string[]
}

export interface SaveRoutePayload { productArticleId: string; notes: string | null; operations: SaveRouteOperationPayload[] }

export const listRoutes = () => api.get<RouteListItem[]>('/productie/rute').then((r) => r.data)
export const getRoute = (id: string) => api.get<RouteDetail>(`/productie/rute/${id}`).then((r) => r.data)
export const createRoute = (payload: SaveRoutePayload) => api.post<{ id: string }>('/productie/rute', payload).then((r) => r.data)
export const updateRoute = (id: string, payload: SaveRoutePayload) => api.put(`/productie/rute/${id}`, payload)
export const submitRouteForApproval = (id: string) =>
  api.post<{ pendingApproval: boolean }>(`/productie/rute/${id}/submit-aprobare`).then((r) => r.data)
export const archiveRoute = (id: string) => api.post(`/productie/rute/${id}/arhiveaza`)
